import { render, staticRenderFns } from "./PurchaseOrders.vue?vue&type=template&id=65c883ca&scoped=true&"
import script from "./PurchaseOrders.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrders.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOrders.vue?vue&type=style&index=0&id=65c883ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c883ca",
  null
  
)

export default component.exports